(function () {
  "use strict";

  var contract = {
    contractVersion: "1.1.0",
    datasetId: "kj6er-pota-performer-nec4",
    acceptedManifestVersions: ["1.1.0"],
    requiredBandsMetres: [20, 17, 15, 12, 10, 6],
    requiredRadialAnglesDegrees: [90, 180],
    requiredProfilesPerCase: ["pattern"],
    requiredMetrics: ["frequencyMHz", "radiatorLengthM", "radialLengthM", "feedpointHeightM", "peakNecGainDbi", "peakAzimuthDegrees", "peakElevationDegrees", "feedpointImpedanceOhms", "sourceModel", "runId", "necVersion", "gainDefinition", "operatorMeaning", "limitation"],
    requiredGovernance: ["status", "reviewedBy", "reviewedAt", "limitations", "sourceFiles", "sha256"],
    acceptedStatus: "accepted",
    currentStatus: "accepted"
  };

  var validate = function (dataset) {
    var errors = [];
    if (!dataset || typeof dataset !== "object") errors.push("Dataset is missing.");
    if (errors.length) return { accepted: false, errors: errors };
    if (contract.acceptedManifestVersions.indexOf(String(dataset.manifestVersion || "")) === -1) errors.push("Unsupported manifest version.");
    if (!dataset.validation || dataset.validation.status !== contract.acceptedStatus) errors.push("Engineering acceptance is missing.");
    var cases = Array.isArray(dataset.cases) ? dataset.cases : [];
    contract.requiredBandsMetres.forEach(function (band) {
      contract.requiredRadialAnglesDegrees.forEach(function (angle) {
        var found = cases.some(function (item) { return Number(item.bandMetres) === band && Number(item.radialAngleDegrees) === angle; });
        if (!found) errors.push("Missing " + band + " m / " + angle + " degree case.");
      });
    });
    cases.forEach(function (item, index) {
      contract.requiredMetrics.forEach(function (key) { if (item[key] === undefined || item[key] === null || item[key] === "") errors.push("Case " + (index + 1) + " is missing " + key + "."); });
      contract.requiredProfilesPerCase.forEach(function (profile) { if (!item.assets || !item.assets[profile]) errors.push("Case " + (index + 1) + " is missing the " + profile + " asset."); });
      if (item.peakRealizedGainDbi !== undefined) errors.push("Case " + (index + 1) + " incorrectly labels modeled NEC gain as realised gain.");
    });
    contract.requiredGovernance.forEach(function (key) { if (!dataset.validation || dataset.validation[key] === undefined || dataset.validation[key] === null || dataset.validation[key] === "") errors.push("Validation record is missing " + key + "."); });
    return { accepted: errors.length === 0, errors: errors };
  };

  window.CHA_PORTABLE_VERTICAL_NEC_IMPORT = { contract: contract, validate: validate };
})();
